import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-sn.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-sn.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "src/app/shared/constants/shared.constants";
import { ViewApplicationLocationSnConstant } from "./view-application-location-sn.constant";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { first } from "rxjs";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApplicationCreateService } from "../../../../create-application/shared/application-create.service";
export let ViewApplicationLocationSnComponent = class ViewApplicationLocationSnComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    mapService;
    applicationCreateService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    activeTabIndex;
    locationForm;
    descriptionLabel1 = ViewApplicationLocationSnConstant.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationSnConstant.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationSnConstant.DESCRIPTION_LABEL_3;
    validationMessages = ViewApplicationLocationSnConstant.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.NO_OPTION_SELECTED;
    showPrivateStreetAreaOrEstateNameField = true;
    showCurrentNameField = true;
    showFeatureTypeField = true;
    showRequiredAsteriskForTheAreaEstateNameField = false;
    showRequiredAsteriskForTheCurrentNameField = false;
    streetOrFeatureLookUps = ViewApplicationLocationSnConstant.STREET_OR_FEATURE_LOOKUPS;
    publicOrPrivateLookUps = ViewApplicationLocationSnConstant.PUBLIC_OR_PRIVATE_LOOKUPS;
    isNewDevelopmentLookUps = ViewApplicationLocationSnConstant.IS_NEW_DEVELOPMENT_LOOKUPS;
    haveExistingNameLookUps = ViewApplicationLocationSnConstant.HAVE_EXISTING_NAME_LOOKUPS;
    streetOrFeatureLabel = ViewApplicationLocationSnConstant.STREET_OR_FEATURE_LABEL;
    publicOrPrivateLabel = ViewApplicationLocationSnConstant.PUBLIC_OR_PRIVATE_LABEL;
    privateStreetAreaOrEstateNameLabel = ViewApplicationLocationSnConstant.PRIVATE_STREET_AREA_OR_ESTATE_NAME_LABEL;
    isNewDevelopmentLabel = ViewApplicationLocationSnConstant.IS_NEW_DEVELOPMENT_NAME_LABEL;
    haveExistingNameLabel = ViewApplicationLocationSnConstant.HAVE_EXISTING_NAME_LABEL;
    currentNameLabel = ViewApplicationLocationSnConstant.CURRENT_NAME_LABEL;
    locationDescriptionLabel = ViewApplicationLocationSnConstant.LOCATION_DESCRIPTION_LABEL;
    wardLabel = ViewApplicationLocationSnConstant.WARD_LABEL;
    proposedNameLabel = ViewApplicationLocationSnConstant.PROPOSED_NAME_LABEL;
    proposedNameLanguageLabel = ViewApplicationLocationSnConstant.PROPOSED_NAME_LANGUAGE_LABEL;
    proposedNameMeaningLabel = ViewApplicationLocationSnConstant.PROPOSED_NAME_MEANING_LABEL;
    proposedNameOriginLabel = ViewApplicationLocationSnConstant.PROPOSED_NAME_ORIGIN_LABEL;
    proposedAlternativeNameLabel = ViewApplicationLocationSnConstant.PROPOSED_ALTERNATIVE_NAME_LABEL;
    languageOfTheAlternativeNameLabel = ViewApplicationLocationSnConstant.LANGUAGE_OF_THE_ALTERNATIVE_NAME_LABEL;
    meaningAlternativeNameLabel = ViewApplicationLocationSnConstant.MEANING_OF_THE_ALTERNATIVE_NAME_LABEL;
    featureTypeLabel = ViewApplicationLocationSnConstant.FEATURE_TYPE_LABEL;
    reasonForChangeLabel = ViewApplicationLocationSnConstant.REASON_FOR_CHANGE_LABEL;
    saveBtnPlaceholder = ViewApplicationLocationSnConstant.SAVE_BUTTON_PLACEHOLDER;
    featuresFormArrayName = ViewApplicationLocationSnConstant.FEATURES_FORM_ARRAY_NAME;
    locationFormGroupName = ViewApplicationLocationSnConstant.LOCATION_FORM_GROUP_NAME;
    streetOrFeatureFormControlName = ViewApplicationLocationSnConstant.STREET_OR_FEATURE_FORM_CONTROL_NAME;
    publicOrPrivateFormControlName = ViewApplicationLocationSnConstant.PUBLIC_OR_PRIVATE_FORM_CONTROL_NAME;
    privateStreetAreaOrEstateNameFormControlName = ViewApplicationLocationSnConstant.PRIVATE_STREET_AREA_OR_ESTATE_NAME_FORM_CONTROL_NAME;
    isNewDevelopmentFormControlName = ViewApplicationLocationSnConstant.IS_NEW_DEVELOPMENT_FORM_CONTROL_NAME;
    haveExistingNameFormControlName = ViewApplicationLocationSnConstant.HAVE_EXISTING_NAME_FORM_CONTROL_NAME;
    currentNameFormControlName = ViewApplicationLocationSnConstant.CURRENT_NAME_FORM_CONTROL_NAME;
    locationDescriptionFormControlName = ViewApplicationLocationSnConstant.LOCATION_DESCRIPTION_FORM_CONTROL_NAME;
    wardFormControlName = ViewApplicationLocationSnConstant.WARD_FORM_CONTROL_NAME;
    proposedNameFormControlName = ViewApplicationLocationSnConstant.PROPOSED_NAME_FORM_CONTROL_NAME;
    proposedNameLanguageFormControlName = ViewApplicationLocationSnConstant.PROPOSED_NAME_LANGUAGE_FORM_CONTROL_NAME;
    proposedNameMeaningFormControlName = ViewApplicationLocationSnConstant.PROPOSED_NAME_MEANING_FORM_CONTROL_NAME;
    proposedAlternativeNameFormArrayName = ViewApplicationLocationSnConstant.PROPOSED_ALTERNATIVE_NAME_FORM_CONTROL_NAME;
    proposedNameOriginFormControlName = ViewApplicationLocationSnConstant.PROPOSED_NAME_ORIGIN_FORM_CONTROL_NAME;
    featureTypeFormControlName = ViewApplicationLocationSnConstant.FEATURE_TYPE_FORM_CONTROL_NAME;
    reasonForChangeFormControlName = ViewApplicationLocationSnConstant.REASON_FOR_CHANGE_FORM_CONTROL_NAME;
    SharedConstants = SharedConstants;
    mapComponent;
    isMapLoaded = false;
    application;
    applicationLoaded = false;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appControllerService, mapService, applicationCreateService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.mapService = mapService;
        this.applicationCreateService = applicationCreateService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.listenForSelectedApplication();
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.listenForRouteParamChange();
    }
    loadMetadata() {
    }
    ngAfterViewInit() {
        this.mapService.actionStreetEnabled = false;
        this.mapService.actionPOIEnabled = false;
    }
    getFeatures() {
        if (this.locationForm) {
            return this.locationForm.get(this.featuresFormArrayName);
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionStreetEnabled = false;
        this.mapService.actionPOIEnabled = false;
        this.mapService.destroyMap();
        super.ngOnDestroy();
    }
    getAlternativeNameFormControls(featureIndex) {
        if (this.locationForm) {
            return this.getFeatures().controls[featureIndex].get(this.proposedAlternativeNameFormArrayName);
        }
    }
    handleRouteChange() {
    }
    syncMapGeometries() {
        const geometries = [];
        const features = this.getFeatures().controls;
        if (features.length > 0) {
            this.getFeatures().controls.forEach(featureControl => {
                const geom = featureControl.get("geometry").value;
                if (geom !== null) {
                    geometries.push(geom);
                }
            });
            if (geometries.length > 0) {
                this.mapComponent.addGeometriesOnMap(geometries, "POI graphics", true);
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    initForm() {
        this.locationForm = this.aflaModuleStrategyService.form.get(this.locationFormGroupName);
        this.activeTabIndex = 0;
    }
    listenForSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.pipe(first()).subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.getApplicationLocationDetails(application);
                    this.applicationLoaded = true;
                }
            }
        });
    }
    getApplicationLocationDetails(application) {
        const params = {
            $expand: `location($expand=alternativeNames),line,polygon`,
            $filter: `jobId eq ${application.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
        };
        try {
            this.cleanupAfterDestroy(this.aflaModuleStrategyService.getApplicationsQuery(params)).subscribe({
                next: (response) => {
                    application.location = response.value[0]?.location;
                    application.line = response.value[0]?.line;
                    application.polygon = response.value[0]?.polygon;
                    this.application = application;
                    this.onGetApplicationDataCompleted(application);
                    this.applicationLoaded = true;
                }, error: (error) => {
                    this.appControllerService.handleServerErrorMessage("location details", error, CRUDOperation.Get);
                }
            });
        }
        catch (e) {
            this.requestStatusService.clearBusyRequestCounter();
        }
    }
    onGetApplicationDataCompleted(application) {
        this.getFeatures().clear();
        const shape = application.location.streetOrFeature?.toLowerCase() === "street" ? application.line.shape : application.polygon.shape;
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(shape, 102100);
        const featureControl = this.getFeatures();
        const featureFormGroup = this.createFeatureFormGroup(application);
        const url = this.getGPToolURL();
        const formData = this.getGPToolFormData(geometryArc);
        this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
            next: (trueCentroidResponse) => {
                this.configureInitialFeatureForm(featureFormGroup);
                this.setTrueCentroid(featureFormGroup, trueCentroidResponse, featureControl);
                if (this.isMapLoaded) {
                    this.syncMapGeometries();
                }
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationLocationSnConstant.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    configureInitialFeatureForm(formGroup) {
        const streetOrFeatureValue = formGroup.get(this.streetOrFeatureFormControlName).value;
        if (streetOrFeatureValue?.toLowerCase() === "street") {
            this.configureFormsForSelectedStreet(formGroup);
        }
        if (streetOrFeatureValue?.toLowerCase() === "feature") {
            this.configureFormsForSelectedFeature(formGroup);
        }
        this.showOrHideCurrentNameField(formGroup);
    }
    configureFormsForSelectedStreet(formGroup) {
        this.showStreetSpecificFields();
        this.addStreetSpecificFieldsValidators(formGroup);
        this.clearValidationOfFeatureSpecificFields(formGroup);
        this.hideFeatureSpecificFields();
        this.changeDetectorRefs.detectChanges();
    }
    hideFeatureSpecificFields() {
        this.showFeatureTypeField = false;
    }
    clearValidationOfFeatureSpecificFields(formGroup) {
        formGroup.get(this.featureTypeFormControlName).reset("");
        formGroup.get(this.featureTypeFormControlName).clearValidators();
        formGroup.get(this.featureTypeFormControlName).disable();
        formGroup.updateValueAndValidity();
    }
    showStreetSpecificFields() {
        this.showPrivateStreetAreaOrEstateNameField = true;
        this.showCurrentNameField = true;
    }
    addStreetSpecificFieldsValidators(formGroup) {
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).enable();
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).addValidators(Validators.required);
        this.showPrivateStreetAreaOrEstateNameField = true;
        formGroup.get(this.currentNameFormControlName).enable();
        formGroup.get(this.currentNameFormControlName).addValidators(Validators.required);
        this.showRequiredAsteriskForTheCurrentNameField = true;
        formGroup.updateValueAndValidity();
    }
    configureFormsForSelectedFeature(formGroup) {
        this.clearValidationOfStreetSpecificFields(formGroup);
        this.hideStreetSpecificFields();
        this.clearFeatureTypeValidators(formGroup);
        this.hideFeatureSpecificFields();
        this.changeDetectorRefs.detectChanges();
    }
    clearFeatureTypeValidators(formGroup) {
        formGroup.get(this.featureTypeFormControlName).clearValidators();
        formGroup.updateValueAndValidity();
    }
    hideStreetSpecificFields() {
        this.showPrivateStreetAreaOrEstateNameField = false;
        this.showCurrentNameField = false;
    }
    clearValidationOfStreetSpecificFields(formGroup) {
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).enable();
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).reset("");
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).clearValidators();
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).disable();
        formGroup.get(this.currentNameFormControlName).enable();
        formGroup.get(this.currentNameFormControlName).reset("");
        formGroup.get(this.currentNameFormControlName).clearValidators();
        formGroup.get(this.currentNameFormControlName).disable();
        formGroup.updateValueAndValidity();
    }
    showOrHideCurrentNameField(formGroup) {
        const currentNameValue = formGroup.get(this.currentNameFormControlName).value;
        if (currentNameValue) {
            this.showCurrentNameField = true;
            this.showRequiredAsteriskForTheCurrentNameField = true;
            formGroup.get(this.currentNameFormControlName).enable();
            formGroup.get(this.currentNameFormControlName).setValidators(Validators.required);
        }
        else {
            this.showRequiredAsteriskForTheCurrentNameField = false;
            formGroup.get(this.currentNameFormControlName).clearValidators();
            formGroup.get(this.currentNameFormControlName).setValue("");
            formGroup.get(this.currentNameFormControlName).updateValueAndValidity();
            formGroup.get(this.currentNameFormControlName).disable();
            this.showCurrentNameField = false;
        }
        formGroup.get(this.streetOrFeatureFormControlName).updateValueAndValidity();
    }
    createFeatureFormGroup(application) {
        let geometryArc;
        if (application.location.streetOrFeature?.toLowerCase()?.trim() === "street") {
            geometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.line.shape, 102100);
        }
        if (application.location.streetOrFeature?.toLowerCase()?.trim() === "feature") {
            geometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.polygon.shape, 102100);
        }
        const geom = JsonUtils.fromJSON(geometryArc);
        const featureFormGroup = new FormGroup({
            objectId: new FormControl({ value: application.location.id, disabled: true }),
            currentName: new FormControl({ value: application.location.currentName, disabled: true }, [Validators.required]),
            centroid: new FormControl(null, [Validators.required]),
            streetOrFeature: new FormControl({ value: application.location.streetOrFeature, disabled: true }),
            publicOrPrivate: new FormControl({ value: application.location.publicOrPrivate, disabled: true }, Validators.required),
            areaEstateName: new FormControl({ value: application.location.areaEstateName, disabled: true }),
            isNewDevelopment: new FormControl({ value: application.location.isNewDevelopment, disabled: true }, Validators.required),
            haveExistingName: new FormControl({ value: application.location.haveExistingName, disabled: true }, Validators.required),
            locationDescription: new FormControl({ value: application.location.locationDescription, disabled: true }, Validators.required),
            geometry: new FormControl(geom),
            ward: new FormControl({ value: application.location.ward, disabled: true }, Validators.required),
            proposedName: new FormControl({ value: application.location.proposedName, disabled: true }, Validators.required),
            proposedNameLanguage: new FormControl({ value: application.location.proposedNameLanguage, disabled: true }, Validators.required),
            proposedNameMeaning: new FormControl({ value: application.location.proposedNameMeaning, disabled: true }, Validators.required),
            proposedNameOrigin: new FormControl({ value: application.location.proposedNameOrigin, disabled: true }, Validators.required),
            featureType: new FormControl({ value: application.location.featureType, disabled: true }, Validators.required),
            reasonForChange: new FormControl({ value: application.location.reasonForChange, disabled: true }, Validators.required),
            alternativeNames: new FormArray([], Validators.required)
        });
        const alternativeNamesControl = featureFormGroup.get(this.proposedAlternativeNameFormArrayName);
        application.location.alternativeNames.forEach((alternativeNameDetails) => {
            const alternativeGroup = new FormGroup({
                id: new FormControl(0),
                deleted: new FormControl(false),
                name: new FormControl({ value: alternativeNameDetails.name, disabled: true }, Validators.required),
                language: new FormControl(alternativeNameDetails.language, Validators.required),
                meaning: new FormControl(alternativeNameDetails.meaning, Validators.required)
            });
            alternativeNamesControl.push(alternativeGroup);
        });
        return featureFormGroup;
    }
    getGPToolURL() {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        return `${proxyUrl}?${gpToolUrl}`;
    }
    getGPToolFormData(geometry) {
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        return formData;
    }
    setTrueCentroid(featureFormGroup, trueCentroidResponse, featureControl) {
        featureFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        featureControl.push(featureFormGroup);
        this.activeTabIndex = featureControl.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: ApplicationCreateService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationSnComponent = __decorate([
    Component({
        selector: "app-view-application-location-sn",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationLocationSnComponent);
